import { render, staticRenderFns } from "./Businesscoop.vue?vue&type=template&id=485f67be&scoped=true&"
import script from "./Businesscoop.vue?vue&type=script&lang=js&"
export * from "./Businesscoop.vue?vue&type=script&lang=js&"
import style0 from "./Businesscoop.vue?vue&type=style&index=0&id=485f67be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485f67be",
  null
  
)

export default component.exports